/* eslint-disable no-console */
import React from 'react';
import PropTypes from 'prop-types';
import { compose, lifecycle, branch, renderNothing, setPropTypes } from 'recompose';
import { connect } from 'react-redux';
import PaymentWizard from './PaymentWizard';
import { loadPaymentPageRequest, loadPaymentPageRequestAfterLogin } from './actions';
import { loadOfferInfoAfterLoginRequest } from '../../actions/campaignOfferInfo';
import Heading from '../Heading';
import styles from './PaymentPage.scss';

export const PaymentPage = () => (
  <section className={styles.root}>
    <div className={styles.updateSubscription}>
      <Heading showDescription={false} />
      <PaymentWizard />
    </div>
  </section>
);

const isValidBase64 = (input) => {
  const decoded = atob(input);
  const encoded = btoa(decoded);

  return input.replaceAll('=', '') === encoded.replaceAll('=', '');
};

const getSelectedStateHash = () => {
  // window.location.hash returns empty string if not present
  if (!window.location.hash.includes('state')) return null;

  const state = window.location.hash.split('=')[1];

  // state is not set
  if (!state) return null;

  if (!isValidBase64(state)) return null;

  const parsedState = JSON.parse(atob(state));

  return parsedState;
};

export default compose(
  connect(
    ({ subscriptions: { selected, options }, userInfo }) => ({
      selected,
      options,
      authenticated: Boolean(userInfo.data),
    }),
    { loadPaymentPageRequest, loadPaymentPageRequestAfterLogin, loadOfferInfoAfterLoginRequest },
  ),
  lifecycle({
    componentDidMount() {
      const {
        selected,
        history,
        loadPaymentPageRequest,
        loadPaymentPageRequestAfterLogin,
        loadOfferInfoAfterLoginRequest,
      } = this.props;

      const selectedState = getSelectedStateHash();
      if (selected) {
        loadPaymentPageRequest();
      } else if (selectedState && selectedState.hasOwnProperty('id')) {
        loadPaymentPageRequestAfterLogin(selectedState.id);
      } else if (selectedState && selectedState.hasOwnProperty('selectedOption')) {
        loadOfferInfoAfterLoginRequest(selectedState.selectedOption);
      } else {
        history.push('/subscriptions');
        return;
      }
      global.scrollTo(0, 0);
    },
  }),
  branch(props => !props.selected, renderNothing),
  setPropTypes({
    loadPaymentPageRequest: PropTypes.func.isRequired,
    loadPaymentPageRequestAfterLogin: PropTypes.func.isRequired,
  }),
)(PaymentPage);
